module.exports = __webpack_public_path__ + "img/5.24fd624f.jpg";